import z from 'zod';

export type AdvancedSearchFilterType =
	| 'Recipe'
	| 'Menu'
	| 'MenuPlan'
	| 'Ingredient'
	| 'BaseIngredient'
	| 'Accessory';

export const AdvancedSearchFilterTypeSchema: z.ZodType<AdvancedSearchFilterType> = z.enum([
	'Recipe',
	'Menu',
	'MenuPlan',
	'Ingredient',
	'BaseIngredient',
	'Accessory',
]);
